var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSiteLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 20,
    viewBox: "0 0 75 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.0015V20H1.20547H2.41094V10.0015V0.00299943H1.20547H0V10.0015ZM12.6578 0.0863203L12.6885 0.169641L15.9029 10.0848L19.1173 20H20.6553H22.1932L25.4068 10.0872L28.6204 0.174307L28.6531 0.0871202L28.6857 0L27.4593 0.0181969L26.233 0.0363278L23.4933 8.77948L20.7537 17.5226L20.7162 17.561L20.6787 17.5993L17.8817 8.80208L15.0847 0.00486581L13.8559 0.00393262L12.6272 0.00299943L12.6578 0.0863203ZM38.9009 1.13616V2.26933H44.8957H50.8904V1.13616V0.00299943H44.8957H38.9009V1.13616ZM63.1997 6.36531L66.3335 12.7304V16.3652V20H67.539H68.7445V16.4004V12.8008L71.8722 6.40191L75 0.00299943H73.6681H72.3362L70.2832 4.15238L68.2302 8.30175L67.877 8.99098L67.5237 9.68021L65.1489 4.85827L62.7741 0.0363278L61.42 0.0182636L60.0659 0.00026648L63.1997 6.36531ZM38.9009 14.3342V20H45.026H51.1511V18.8668V17.7337H46.2315H41.3118V14.3009V10.868H45.7428H50.1737V9.7682V8.66837H44.5373H38.9009V14.3342Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteLogo);
export default __webpack_public_path__ + "static/media/site-logo.e51ba2e6844bc724f1a6a894f8999404.svg";
export { ForwardRef as ReactComponent };